module.exports = __webpack_public_path__ + "img/animation_500_l3vkfkxp.e033cb99.gif";